const MovieListHeading = (props) => {
    return (
        <div style={{border: 'none', margin: '0%', padding: '0%'}} className="col">
            <h1 style={{border: 'none', margin: '0%', padding: '0%'}}>{props.heading}</h1>
        </div>
    )
}

export default MovieListHeading;